import { useQuery } from '@tanstack/react-query';

import { useAuthor } from '@/hooks/useAuthor';
import { verifyWebAuthor, type WebAuthorVerification } from '@/lib/verifyWebAuthor';

/**
 * Verify a claimed author for a web-sourced highlight. Cached aggressively —
 * page identity declarations rarely change within a session.
 */
export function useVerifyWebAuthor(url: string | undefined, claimedPubkey: string | undefined) {
  const author = useAuthor(claimedPubkey);
  const nip05 = author.data?.metadata?.nip05;

  return useQuery<WebAuthorVerification>({
    queryKey: ['nostr', 'web-author-verify', url ?? '', claimedPubkey ?? '', nip05 ?? ''],
    queryFn: () => verifyWebAuthor(url!, claimedPubkey!, nip05),
    enabled: !!url && !!claimedPubkey,
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });
}
